module.exports = __webpack_public_path__ + "static/media/dropsv.fec12dc7.svg";